// extracted by mini-css-extract-plugin
export default {"container_card":"style_container_card__4euPI","icon_cont":"style_icon_cont__hEvDL","box":"style_box__hcuTo"};